import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { P as PaginationButton } from './PaginationButton-BQUQl9go.js';
import { w as angleDoubleInlineStart } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const PaginationFirstButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-first-button'),
  icon: angleDoubleInlineStart
}, props));
PaginationFirstButton.displayName = 'PaginationFirstButton';

export { PaginationFirstButton as P };
//# sourceMappingURL=PaginationFirstButton-CdL05D0L.js.map
